import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MomSysCodeGenerate ( props ) {

    return <BasicCrudScreenType id="MomSysCodeGenerate" table="MomSysCodeGenerate" view="MomSysCodeGenerate" noExcel noSearch noFilter />;

}

export default MomSysCodeGenerate;
